import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/api/index'
import Nprogress from 'nprogress';
import qs from 'qs'
import router from '@/router/index'
Vue.use(Vuex)
const state = {
    activeSession: [],
    activeCdnhost: '',
    activeSessionRoles: [],
    completedSessionsList: [],
    completedSessionsPermission: [],
    trafficGraphsList: [],
    trafficGraphsPermission: []
}

const mutations = {
    SET_COMPLETED_USERS_SESSIONS(state, userData) {
        var tData = {};
        var parseData = JSON.parse(userData.message);
        state.completedSessionsPermission = userData.permissions;
        state.completedSessionsList = [];
        if (parseData != null) {
            tData['completedSessionsList'] = parseData;
            state.completedSessionsList = tData;
        }
    },
    SET_ACTIVE_SESSIONS(state, userData) {
        var tData = {};
        var parseData = JSON.parse(userData.message);
        state.activeCdnhost = userData.cdnhost;
        state.activeSessionRoles = userData.roles;
        state.activeSession = [];
        if (parseData != null) {
            tData[userData.accountId + '-activeSessionList'] = parseData;
            state.activeSession = tData;

        }
    },
    SET_TRAFFIC_GRAPHS_LIST(state, userData) {
        var tData = {};
        var parseData = userData.message;
        state.trafficGraphsPermission = userData.permissions;
        state.trafficGraphsList = [];
        if (parseData != null) {
            tData[userData.accountId + '-trafficGraphsList'] = parseData;
            state.trafficGraphsList = tData;
        }
    },
    DELETE_ACTIVE_SESSIONS(state, userData) {
        if (Object.keys(state.activeSession).length != 0) {
            for (var i = 0; i < userData.id.length; i++) {
                var index = state.activeSession[userData.account_id + "-activeSessionList"].findIndex(fupd => fupd.UserSession.id == userData.id[i]);
                state.activeSession[userData.account_id + "-activeSessionList"].splice(index, 1)
            }
        }
    },
    CLEAR_MONITORING_STATE(state) {
        state.activeSession = [];
        state.activeCdnhost = '';
        state.activeSessionRoles = [];
    },

}

const actions = {
    fetchCompletedUserSessionsList({
        commit,
        dispatch
    }, authData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.get('/monitoring/completed_sessions_data/' + authData.customDateFrom + "/" + authData.customDateTo + "/" + authData.mac + "/" + true + '/' + authData.limit + '/' + authData.page + '/' + authData.search + '/' + authData.sorting)
                .then(res => {
                    loader.hide();
                    if (res.data.status == "redirect") {
                        router.push(res.data.message);
                    }else if(res.data.status=="error" && res.data.isDatabaseAccessibleCheck=="yes"){
                        resolve(res.data);
                      } else {
                        commit('SET_COMPLETED_USERS_SESSIONS', res.data)
                    }
                    resolve(res.data);
                })
                .catch(error => console.log(error))
        });
    },
    geTrafficGraphsDetails({
        commit,
        dispatch
    }, authData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.get('/monitoring/traffic_graphs/true')
                .then(res => {
                    loader.hide();
                    if(res.data.status=="error" && res.data.isDatabaseAccessibleCheck=="yes"){
                        resolve(res.data);
                        return;    
                    }
                    commit('SET_TRAFFIC_GRAPHS_LIST', res.data)
                    resolve(res.data);
                })
                .catch(error => console.log(error))
        });
    },
    changeZone({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/monitoring/user_traffic_graph', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    UpdateInterfaceTraffic({
        commit,
        dispatch
    }, authData) {
        Nprogress.start()
        return new Promise((resolve, reject) => {
            axios.get('/monitoring/get_traffic')
                .then(res => {
                    Nprogress.done()
                    if (res.data.status == "redirect") {
                        router.push(res.data.message);
                    } else {
                        resolve(res.data);
                    }
                })
                .catch(error => console.log(error))
        });
    },
    geTrafficUsageDetails({
        commit,
        dispatch
    }, authData) {
        Nprogress.start()
        return new Promise((resolve, reject) => {
            axios.get('/monitoring/traffic_usage/' + authData.userId + '/true')
                .then(res => {
                    Nprogress.done()
                    resolve(res.data);
                })
                .catch(error => console.log(error))
        });
    },
    exportTrafficUsageAsPdf({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/users/export_mrtg_pdf', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    window.open("/backend" + response.data.message);
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    fetchActiveSessionsList({
        commit,
        dispatch
    }, authData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/monitoring/active_sessions_data', qs.stringify(authData, {
                parseArrays: false
            }))
                // axios.get('/monitoring/active_sessions_data/both/' + authData.ipsearch + '/' + authData.accountId + '/' + authData.nassearch + '/' + authData.fupType + '/' + authData.sessionType + '/' + true + '/' + authData.limit + '/' + authData.page + '/' + authData.search + '/' + authData.sorting)
                .then(res => {
                    loader.hide();
                    if (res.data.status == "redirect") {
                        router.push(res.data.message);
                    }else if(res.data.status=="error" && res.data.isDatabaseAccessibleCheck=="yes"){
                        resolve(res.data);
                        return;
                     } else {
                        commit('SET_ACTIVE_SESSIONS', res.data)
                    }
                    resolve(res.data);
                })
                .catch(error => console.log(error))
        });
    },
    terminateUserSession({
        commit,
        dispatch
    }, authData) {
        let loader = Vue.$loading.show({
            canCancel: false,
        });
        axios.post('/monitoring/terminate_session', qs.stringify(authData, {
            parseArrays: false
        }))
            .then(response => {
                loader.hide()
                if (response.data.status != 'success') {
                    return;
                }
                commit('DELETE_ACTIVE_SESSIONS', authData)
            })
            .catch(error => console.log(error));

    },
    hardDisconnectSessions({
        commit,
        dispatch
    }, authData) {
        let loader = Vue.$loading.show({
            canCancel: false,
        });
        return new Promise((resolve, reject) => {
            axios.post('/monitoring/hardDisconnect', qs.stringify(authData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    }, removeAllHostsSubmit({
        commit,
        dispatch
    }, authData) {
        let loader = Vue.$loading.show({
            canCancel: false,
        });
        return new Promise((resolve, reject) => {
            axios.post('/monitoring/removeAllHost', qs.stringify(authData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    }, removeAllSessionSubmit({
        commit,
        dispatch
    }, authData) {
        let loader = Vue.$loading.show({
            canCancel: false,
        });
        return new Promise((resolve, reject) => {
            axios.post('/monitoring/removeAllSessions', qs.stringify(authData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    clearMonitoringsState({
        commit,
        dispatch
    }) {
        commit('CLEAR_MONITORING_STATE')
    },
    terminateSelectedUsers({
        commit,
        dispatch
    }, authData) {
        let loader = Vue.$loading.show({
            canCancel: false,
        });
        return new Promise((resolve, reject) => {
            axios.post('/monitoring/terminate_session', qs.stringify(authData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },

}

const getters = {
    getActiveSessionListGetters: state => {
        return state.activeSession;
    },
    getActiveCdnhostGetters: state => {
        return state.activeCdnhost;
    },
    getActiveRolesGetters: state => {
        return state.activeSessionRoles;
    },
    getCompletedSessionsGetters: state => {
        return state.completedSessionsList;
    },
    getCompletedSessionsPermissionGetters: state => {
        return state.completedSessionsPermission;
    },
    getTrafficGraphsListGetters: state => {
        return state.trafficGraphsList;
    },
    getTrafficGraphsPermissionGetters: state => {
        return state.trafficGraphsPermission;
    },
}

export default {
    state,
    mutations,
    actions,
    getters
}
